import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedDevolucionesAgregarManualComponent {
  agregarManual = true
  catalogos
  data = {
    data: {
      moneda: 'MXN',
      id_moneda: 1,
      tipo_cambio: 1,
      deducible: false,
      id_categoria: '072',
      notas: '',
    },
    archivo: null,
    errores: 0,
    advertencias: 0,
    mensajes: [],
    pdf: null,
  }
  saldo
  onClose
  operadora

  $onInit () {
    this.saldo = Math.round((this.saldo + Number.EPSILON) * 100) / 100
  }

  cerrar (data) {
    this.agregarManual = false
    this.data = data ? [data] : []
    this.onClose({$event: {detail: this.data}})
  }
}

module.component('viaticosSharedDevolucionesAgregarManual', {
  controller: ViaticosSharedDevolucionesAgregarManualComponent,
  template,
  bindings: {
    catalogos: '<',
    operadora: '<',
    saldo: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/devoluciones/agregar/manual/component.js